/* unplugin-vue-components disabled */import { render } from "./newMusic.vue?vue&type=template&id=f5efb772&scoped=true&ts=true"
import script from "./newMusic.vue?vue&type=script&lang=ts"
export * from "./newMusic.vue?vue&type=script&lang=ts"

import "./newMusic.vue?vue&type=style&index=0&id=f5efb772&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5efb772"],['__file',"src/views/latestMusic/cpns/newMusic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5efb772"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5efb772', __exports__)) {
    console.log('reload')
    api.reload('f5efb772', __exports__)
  }
  
  module.hot.accept("./newMusic.vue?vue&type=template&id=f5efb772&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('f5efb772', render)
  })

}


export default __exports__